export interface ClientAccessModel {
  // General access section.
  canReadClientStory: boolean;
  canReadDebts: boolean;
}


export const CLIENT_ACCESS_DEFAULT: ClientAccessModel = {
  canReadClientStory: false,
  canReadDebts: false
};
